/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="85.61"
        height="95.45"
        viewBox="0 0 85.61 95.45"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M62.44 44.25a15.42 15.42 0 1 0 15.42 15.44 15.42 15.42 0 0 0-15.42-15.44Zm0 2a13.42 13.42 0 1 1-13.42 13.44 13.42 13.42 0 0 1 13.42-13.44Z"
          className="icon-fill icon-accent"/><path
          fill="#ffb81c"
          d="M62.44 44.28c-4.27 0-7 6.64-7 15.39 0 .93 0 1.85.09 2.73l.06.75c.66 6.93 3.26 11.91 6.89 11.91s6.13-4.83 6.84-11.55l.07-.75c.09-1 .13-2 .13-3.09-.04-8.69-2.87-15.39-7.08-15.39Zm0 2c2 0 3.91 3.35 4.67 8.38l.1.66v.34l.07.69a32.12 32.12 0 0 1 .16 3.32c0 .64 0 1.26-.05 1.87v.72c-.47 6.32-2.62 10.8-4.94 10.8-2.64 0-5-5.7-5-13.39a36.56 36.56 0 0 1 .22-4l.09-.68c0-.22.06-.44.1-.65l.11-.64c.13-.73.3-1.42.48-2.06l.16-.54c.89-3.01 2.31-4.82 3.83-4.82Z"
          className="icon-fill icon-accent"/><path
          fill="#ffb81c"
          d="M74.94 51.47a1.002 1.002 0 0 1 .11 2H49.94a1.002 1.002 0 0 1-.12-2h25.12Z"
          className="icon-fill icon-accent"/><path
          fill="#ffb81c"
          d="M76.86 58.69a1.002 1.002 0 0 1 .12 2h-29a1.002 1.002 0 0 1-.12-2h29Z"
          className="icon-fill icon-accent"/><path
          fill="#ffb81c"
          d="M74.94 65.8a1.002 1.002 0 0 1 .11 2H49.9a1.002 1.002 0 0 1-.12-2h25.16Z"
          className="icon-fill icon-accent"/><path
          fill="#fff"
          d="M68.77 74.47a1.25 1.25 0 0 1 2.2 1.18l-.06.12-3.7 6.1a1.25 1.25 0 0 1-2.2-1.18l.06-.12Z"
          className="icon-fill icon-base"/><path
          fill="#fff"
          d="M64.98 80.85a1.26 1.26 0 0 1 1.45-.85h.12l6.91 2.18a1.25 1.25 0 0 1-.63 2.42h-.12l-6.94-2.19a1.25 1.25 0 0 1-.79-1.56Z"
          className="icon-fill icon-base"/><path
          fill="#fff"
          d="M65.46 37.69a1.27 1.27 0 0 1 1.48-1 23.28 23.28 0 0 1-.55 45.74 1.25 1.25 0 1 1-.44-2.46 20.77 20.77 0 0 0 .49-40.82 1.26 1.26 0 0 1-.98-1.46Z"
          className="icon-fill icon-base"/><path
          fill="#fff"
          d="M57.28 37.33a1.25 1.25 0 0 1 2.2 1.17l-.07.12-3.7 6.11a1.25 1.25 0 0 1-2.2-1.18l.06-.12Z"
          className="icon-fill icon-base"/><path
          fill="#fff"
          d="M50.23 35.42a1.26 1.26 0 0 1 1.45-.85h.12l6.91 2.18a1.25 1.25 0 0 1-.63 2.42h-.12l-6.91-2.19a1.25 1.25 0 0 1-.82-1.56Z"
          className="icon-fill icon-base"/><path
          fill="#fff"
          d="M58.13 36.8a1.23 1.23 0 0 1 1.44 1 1.25 1.25 0 0 1-1 1.45 20.77 20.77 0 0 0-.49 40.82 1.25 1.25 0 1 1-.49 2.45 23.27 23.27 0 0 1 .55-45.73Z"
          className="icon-fill icon-base"/><path
          fill="#fff"
          d="M38.93.32a1.26 1.26 0 0 1 1.67 0c10.21 9.15 22.39 13.73 37.72 14.19a1.25 1.25 0 0 1 1.2 1.12V35.6a1.25 1.25 0 1 1-2.5-.07V16.94h-.25c-14.72-.7-26.71-5.2-36.82-13.89l-.18-.14-.17.14c-10 8.54-21.7 13-36.09 13.85h-1v18c.27 12.74 1.88 22.3 5.8 30.89l.24.52c5.56 11.87 15.43 20.7 30.93 26.42l.25.09.46-.16a69.56 69.56 0 0 0 11.78-5.62l.69-.43a1.24 1.24 0 0 1 1.72.39 1.26 1.26 0 0 1-.39 1.73 72.1 72.1 0 0 1-13.83 6.6 1.24 1.24 0 0 1-.85 0c-16.5-5.93-27.09-15.3-33-27.95C2.46 59.16.68 50.21.16 38.75L.1 37.24c0-.76 0-1.54-.06-2.32v-19.2a1.25 1.25 0 0 1 1.21-1.25c15.29-.42 27.52-5 37.68-14.15Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'ShieldWithGlobe2ArrowsIcon';

export default Icon;
